import React from 'react';
import { MonitorPlay } from 'lucide-react';
import RigFleetCard from './RigFleetCard';

export default function FleetGrid({ bays, feeds, busyRigId, onSanitise, onLogFault }) {
  return (
    <section className="flex-1 min-h-0 flex flex-col">
      <div className="flex items-center justify-between px-5 pt-5 pb-4">
        <h2 className="flex items-center gap-2 text-white font-black text-base uppercase tracking-tight">
          <MonitorPlay className="w-4 h-4 text-primary" /> Fleet Grid
        </h2>
        <span className="text-white/40 text-[11px] font-bold tracking-widest">{bays.length} BAYS</span>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto px-5 pb-5">
        {bays.length === 0 ? (
          <p className="text-white/30 text-sm text-center py-16 border border-white/5">
            No bays configured yet — set a bay number on each rig in the admin rig manager.
          </p>
        ) : (
          <div className="grid grid-cols-2 xl:grid-cols-3 gap-3">
            {bays.map((rig) => (
              <RigFleetCard
                key={rig.id}
                rig={rig}
                feeds={feeds}
                busy={busyRigId === rig.id}
                onSanitise={onSanitise}
                onLogFault={onLogFault}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}